<template>
  <div class="piano-control piano-fatturazioni-control row align-items-baseline px-3">
    <BModal
      dialog-class="modal--type-dialog"
      id="planning-modal"
      ref="planning-modal"
      title="Pianifica"
      centered
    >
      <div class="row">
        <FormInputSelectWidget
          class="col-sm-4 mb-3"
          label="Periodo"
          v-model="planning.period"
          :options="planningPeriodOptions"
        />

        <FormInputSelectWidget
          class="col-sm-4 mb-3"
          label="Dilazione"
          v-model="planning.delay"
          :options="delayPaymentsOptions"
        />
      </div>
      <div class="row">
        <FormInputMonthPickerWidget
          class="col-sm-4"
          label="Mese di inizio"
          v-model="planning.begin"
        />
        <FormInputMonthPickerWidget
          class="col-sm-4"
          label="Mese di fine"
          v-model="planning.end"
        />
        <FormInputAmountWidget
          class="col-sm-4"
          label="Ricavo totale"
          v-model.number="planning.ricavo"
          :min="0"
        />
      </div>
      <template #modal-footer>
        <button class="ml-2 btn btn-primary" @click.prevent="createPlanning">Crea piano fatturazioni</button>
        <button class="ml-2 btn btn-outline-danger" @click.prevent="$refs['planning-modal'].hide()">Chiudi</button>
      </template>
    </BModal>

    <BModal dialog-class="modal--type-dialog" ref="confirm-delete-modal" title="Sei sicuro?" centered>
      <p class="my-4">
        Sei sicuro di voler eliminare tutte le fatture fino ad ora create?
      </p>
      <template #modal-footer>
        <button class="ml-2 btn btn-danger" @click.prevent="deleteAll">Elimina tutto</button>
        <button class="ml-2 btn btn-secondary" @click.prevent="$refs['confirm-delete-modal'].hide()">Annulla</button>
      </template>
    </BModal>

    <div class="col-auto pl-0">
      <FormLabel class="section-title" label-is-fake>{{ label }}</FormLabel>
    </div>
    <div class="col-12 pl-0 pb-3">
      <button :class="totalRemaining > 0 ? 'mr-2 btn btn-primary': 'mr-2 btn btn-secondary' " type="button" :disabled="totalRemaining <= 0" @click.prevent="$refs['planning-modal'].show()">Pianificazione</button>
      <button :class="totalRemaining > 0 ? 'mr-2 btn btn-primary': 'mr-2 btn btn-secondary' " type="button" :disabled="totalRemaining <= 0" @click.prevent="addMonth">Aggiungi fattura</button>
      <button class="mr-2 btn btn-danger" type="button" :disabled="value.length <= 0" @click.prevent="$refs['confirm-delete-modal'].show()">Elimina tutto</button>
    </div>
    <div v-if="cleanedTotal > 0" class="counter col text-right">
      Ancora da fatturare <InvoicedCounter :value="totalRemaining" :total="cleanedTotal"></InvoicedCounter>
    </div>

    <div v-if="cleanedTotal === 0" class="col-12">
      <AlertFeedback status="warning">
        Totale non specificato
      </AlertFeedback>
    </div>

    <b-table v-else hover :items="valuesWithScadenzarioTotal" :fields="tableHeadings" small class="mt-1">

      <template #cell(amount)="row">
        {{row.item.amount | money}}
      </template>

      <template #cell(scadenzarioTotal)="row">
        {{row.item.scadenzarioTotal | money}}
      </template>

      <template #cell(details)="row">
        <button size="sm" @click="row.toggleDetails"  type="button" :class="row.detailsShowing ? 'mr-2 btn btn-primary' : 'mr-2 btn btn-outline-primary'">
          <b-icon-pencil aria-hidden="true"></b-icon-pencil>
        </button>
      </template>

      <template #cell(leftToPlan)="row">
            <template v-if="!row.item.month">-</template>
            <strong v-else>
              {{ leftToPlan(row.item) }}
            </strong>
      </template>

      <template #cell(delete)="row">
        <ActionDelete :show-icons-only="true" @click="removeMonth(row.index)" />
      </template>

      <template #row-details="row">
        <AwlTable class="col-12" :heading="headings" :rows="[...row.item]">

          <template #column-key-month="{ value }">
            <FormInputMonthPickerWidget
              label="Mese"
              hide-label
              :value="value"
              :min="'2022-01'"
              @input="updateMonthInMonth(row.index, $event)"
            />
          </template>

          <template #column-key-amount>
            <template v-if="!row.item.month">-</template>
            <template v-else>
              <FormInputText type="number" :min="1" :step="1" :value="row.item.amount" @input="updateAmountInMonth(row.index, $event)" />
            </template>
          </template>

          <template #column-key-scadenzarioTotal>
            <template v-if="!row.item.month">-</template>
            <strong v-else>
              {{ row.item.scadenzarioTotal | money }}
            </strong>
          </template>

          <template #column-key-scadenzario>
            <FormInputScadenzarioWidget
              :firstMonth="firstMonth"
              :total="row.item.scadenzarioTotal"
              :value="row.item.scadenzario"
              @input="updateScadenzarioInMonth(row.index, $event)"
            />
          </template>
        </AwlTable>
      </template>
    </b-table>
    <div class="col-auto pl-0 pb-3" v-if="showBottomButtons">
      <button :class="totalRemaining > 0 ? 'mr-2 btn btn-primary': 'mr-2 btn btn-secondary' " type="button" :disabled="totalRemaining <= 0" @click.prevent="$refs['planning-modal'].show()">Pianificazione</button>
      <button :class="totalRemaining > 0 ? 'mr-2 btn btn-primary': 'mr-2 btn btn-secondary' " type="button" :disabled="totalRemaining <= 0" @click.prevent="addMonth">Aggiungi fattura</button>
    </div>
    <div v-if="cleanedTotal > 0 && showBottomButtons" class="counter col text-right">
      Ancora da fatturare <InvoicedCounter :value="totalRemaining" :total="cleanedTotal"></InvoicedCounter>
    </div>
  </div>
</template>

<script>
import { BIconPencil, BTable, BModal } from 'bootstrap-vue';
import { nextYearMonth } from '@/helpers/months';
import formatMoney from '@/filters/formatMoney';

export default {
  data () {
    return {
      delayPaymentsOptions: [
        { value: 1, label: '30 giorni' },
        { value: 2, label: '60 giorni' },
        { value: 3, label: '90 giorni' },
        { value: 4, label: '120 giorni' },
      ],
      planningPeriodOptions: [
        { value: 1, label: 'Mensile' },
        { value: 3, label: 'Trimestrale' },
        { value: 6, label: 'Semestrale' },
        { value: 12, label: 'Annuale' },
      ],
      planning: {
        begin: this.startMonth || null,
        end: this.firstMonth || null,
        ricavo: parseInt(this.total),
        period: 1,
        delay: 1,
      },
    };
  },
  components: {
    BIconPencil,
    BModal,
    BTable,
    FormLabel: () => import('@/libs/Form/components/FormLabel'),
    FormInputSelectWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputSelectWidget.vue'),
    AwlTable: () => import('@/libs/Table/components/AwlTable'),
    ActionDelete: () => import('@/views/components/Actions/ActionDelete'),
    InvoicedCounter: () => import('@/views/components/Operative/InvoicedCounter'),
    FormInputMonthPickerWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputMonthPickerWidget'),
    FormInputText: () => import('@/libs/Form/components/Inputs/FormInputText'),
    FormInputScadenzarioWidget: () => import('@/views/components/Operative/Form/Widgets/FormInputScadenzarioWidget'),
    AlertFeedback: () => import('@/libs/Feedback/components/Alert'),
    FormInputAmountWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputAmountWidget'),
  },
  filters: {
    money: formatMoney,
  },
  props: {
    label: {
      type: String,
      default: 'Piano di fatturazione',
    },
    total: {
      type: Number,
      default: 0,
    },
    scadenzarioPercentage: {
      type: Number,
      default: 0,
    },
    value: {
      type: Array,
      default: () => [],
    },
    startMonth: {
      type: String,
      default: '',
    },
    firstMonth: {},
  },
  computed: {
    showBottomButtons () {
      return this.value.length > 15;
    },
    tableHeadings () {
      return [
        { key: 'month', label: 'Mese' },
        { key: 'amount', label: 'Importo' },
        { key: 'scadenzarioTotal', label: 'Importo da scadenzare' },
        { key: 'leftToPlan', label: 'Ancora da scadenzare' },
        { key: 'details', label: 'Modifica' },
        { key: 'delete', label: 'Elimina' },
      ];
    },
    cleanedTotal () {
      return parseInt(this.total || 0);
    },
    valuesWithScadenzarioTotal () {
      return (this.value || []).map(v => {
        v.scadenzarioTotal = this.calculateScadenzarioValue(v.amount);

        return v;
      });
    },
    valueTotal () {
      return this.value.reduce((t, v) => t + v.amount, 0);
    },
    totalRemaining () {
      return this.cleanedTotal - this.valueTotal;
    },
    headings () {
      return [
        { key: 'month', label: 'Mese' },
        { key: 'amount', label: 'Importo' },
        { key: 'scadenzarioTotal', label: 'Importo da scadenzare' },
        { key: 'scadenzario', label: 'Scadenzario' },
        { key: 'actions', label: '' },
      ];
    },
  },
  watch: {
    total: function (a) {
      this.planning.ricavo = a;
    },
    startMonth: function (a) {
      this.planning.begin = a;
    },
    firstMonth: function (a) {
      this.planning.end = a;
    },
  },
  methods: {
    deleteAll () {
      this.emitValue([]);
      this.$refs['confirm-delete-modal'].hide();
    },
    leftToPlan (item) {
      const amount = item.scadenzario.reduce((n, { amount }) => n + amount, 0);
      return item.scadenzarioTotal - amount;
    },
    emitValue (newValue) {
      this.$emit('input', newValue.filter((value, index, self) => self.findIndex(v => v.month === value.month) === index).sort((a, b) => {
        if (a.month === b.month) {
          return 0;
        }

        if (!a.month) {
          return 1;
        }

        if (!b.month) {
          return -1;
        }

        return a.month < b.month ? -1 : 1;
      }));
    },
    getMonthDifference (startDate, endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      return (
        1 +
        end.getMonth() -
        start.getMonth() +
        12 * (end.getFullYear() - start.getFullYear())
      );
    },
    addZeroToMonth (value) {
      return value < 10 ? `0${value}` : value;
    },
    dateRange (startDate, endDate) {
      var start = startDate.split('-');
      var end = endDate.split('-');
      var startYear = parseInt(start[0]);
      var endYear = parseInt(end[0]);
      var dates = [];

      for (var i = startYear; i <= endYear; i++) {
        var endMonth = i !== endYear ? 11 : parseInt(end[1]) - 1;
        var startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
        for (var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j + this.planning.period) {
          var month = j + 1;
          var displayMonth = month < 10 ? '0' + month : month;
          dates.push([i, displayMonth].join('-'));
        }
      }
      return dates;
    },
    createPlanning () {
      let monthsAmount = this.getMonthDifference(this.planning.begin, this.planning.end) / this.planning.period;
      if (monthsAmount > 0) {
        monthsAmount = Math.max(1, monthsAmount);
        const ricavoPerMonth = Math.floor(this.planning.ricavo / (monthsAmount));
        const monthsArray = this.dateRange(this.planning.begin, this.planning.end);
        const amountChange = this.planning.ricavo - (ricavoPerMonth * monthsAmount);
        const newValue = [...this.value];
        monthsArray.forEach((month, i) => {
          const scadenzario = [];
          let amount = Math.max(0, ricavoPerMonth);

          if (amountChange > 0 && i === monthsArray.length - 1) {
            amount += amountChange;
          }
          scadenzario.push({
            month: parseInt(month.split('-')[1]) + this.planning.delay > 12 ? `${parseInt(month.split('-')[0]) + 1}-${this.addZeroToMonth((parseInt(month.split('-')[1]) + this.planning.delay) - 12)}` : `${month.split('-')[0]}-${this.addZeroToMonth(parseInt(month.split('-')[1]) + this.planning.delay)}`,
            amount: this.calculateScadenzarioValue(amount),
          });

          newValue.push({
            month: month,
            amount: amount,
            scadenzario: scadenzario,
          });
        });
        this.emitValue(newValue);
      }
      this.$refs['planning-modal'].hide();
    },
    addMonth () {
      const newValue = [...this.value];

      let month = null;
      if (newValue.length === 0) {
        month = this.firstMonth;
      }

      let amount = 0;
      if (month && newValue.length === 0) {
        amount = Math.max(0, this.totalRemaining);
      }

      const scadenzario = [];
      if (month && newValue.length === 0) {
        scadenzario.push({
          month: nextYearMonth(month),
          amount: this.calculateScadenzarioValue(amount),
        });
      }
      newValue.push({
        month: month,
        amount: amount,
        scadenzario: scadenzario,
      });

      this.emitValue(newValue);
    },
    calculateScadenzarioValue (value) {
      return Math.ceil(parseFloat(value || 0) * (1 + parseFloat(this.scadenzarioPercentage || 0) / 100));
    },
    removeMonth (rowNumber) {
      this.emitValue((this.value || []).filter((r, i) => i !== rowNumber));
    },
    updateAmountInMonth (rowNumber, value) {
      this.emitValue((this.value || []).map((r, i) => {
        if (i === rowNumber) {
          r.amount = parseInt(value) || 0;
        }

        return r;
      }));
    },
    updateScadenzarioInMonth (rowNumber, value) {
      this.emitValue((this.value || []).map((r, i) => {
        if (i === rowNumber) {
          r.scadenzario = value || [];
        }

        return r;
      }));
    },
    updateMonthInMonth (rowNumber, value) {
      this.emitValue((this.value || []).map((r, i) => {
        if (i === rowNumber) {
          r.month = value;

          if (!r.month) {
            r.amount = 0;
          } else if (!r.amount) {
            r.amount = Math.max(0, this.totalRemaining);
          }

          if (!r.month) {
            r.scadenzario = [];
          } else if (!r.scadenzario || !Array.isArray(r.scadenzario) || r.scadenzario.length === 0) {
            r.scadenzario = [
              {
                month: nextYearMonth(r.month),
                amount: r.amount,
              },
            ];
          }
        }

        return r;
      }));
    },
  },
};

</script>

<style lang="scss">
.piano-control {
  #planning-modal{
    height: 400px;
  }
}
</style>
